import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./WhatsAppButton.css";

function WhatsAppButton() {
  const phoneNumber = "923249320453"; 
  const message = "Hello Time Valley, I would like to know more about your watches.";

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="tv-whatsapp"
      aria-label="Chat with us on WhatsApp"
    >
      <FaWhatsapp />

      <span className="tv-whatsapp-tooltip">
        Chat With Us
      </span>
    </a>
  );
}

export default WhatsAppButton;
